// libs
import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'o2web-react-core';


// Props and Context
const propTypes = {
  cardType: PropTypes.oneOf(['artwork', 'activity', 'resource']).isRequired,
  children: PropTypes.node.isRequired,
  slug: PropTypes.string,
};

const defaultProps = {
  slug: '',
};

const contextTypes = {
  t: PropTypes.func,
};

function DefaultCardAction(props, { t }) {
  const { cardType, children, slug } = props;
  return (
    <NavLink to={`/fr/${t(`routes.${cardType}`)}/${slug}`}>
      {children}
    </NavLink>
  );
}

DefaultCardAction.contextTypes = contextTypes;
DefaultCardAction.propTypes = propTypes;
DefaultCardAction.defaultProps = defaultProps;

export default DefaultCardAction;



// WEBPACK FOOTER //
// ./src/app/components/cards/card/cardActions/DefaultCardAction.js